module.exports = __webpack_public_path__ + "files/7f0aa689bbe41cd717f4c2b3f48d1636.png";